import { CommercialEvaluationRepository } from '@src/main/modules/reports/commercial/domain/commercial-evaluation.repository';
import {
  BriefCommercialEvaluation,
  EvaluationCriteria,
} from '@src/main/modules/reports/shared/domain/evaluation.interface';

export const findCommercialEvaluationsByCriteria = async (
  repository: CommercialEvaluationRepository,
  criteria: EvaluationCriteria,
): Promise<{ items: BriefCommercialEvaluation[]; total: number }> =>
  await repository.findByCriteria(criteria);
